module.exports = __webpack_public_path__ + "static/media/icon-ConvensionalAi.7fb958ea.svg";